export const UpstoxOrdersPostback = () => {
    window.close()
    return <></>
}